import React from 'react';
import { CalendarDaysIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

interface BookDemoCardProps {
  variant?: 'default' | 'compact' | 'cta';
}

const BookDemoCard: React.FC<BookDemoCardProps> = ({ variant = 'default' }) => {
  const handleBookDemo = () => {
    const subject = encodeURIComponent('Request for RentSmart Landlord Toolkit Demo');
    const body = encodeURIComponent(
      `Hi RentSmart Team,

I'm interested in learning more about the Landlord Toolkit and would like to schedule a demo.

Name: 
Phone: 
Preferred time: 

Please let me know your availability.

Thank you!`
    );
    window.location.href = `mailto:support@rentsmart.ie?subject=${subject}&body=${body}`;
  };

  if (variant === 'compact') {
    return (
      <button
        onClick={handleBookDemo}
        className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold text-sm hover:bg-blue-700 transition-all shadow-sm hover:shadow-md"
      >
        <CalendarDaysIcon className="w-5 h-5" />
        Book a Demo
      </button>
    );
  }

  if (variant === 'cta') {
    return (
      <button
        onClick={handleBookDemo}
        className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-blue-600 rounded-lg font-bold text-lg hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 border-2 border-blue-600"
      >
        <CalendarDaysIcon className="w-6 h-6" />
        Book a Free Demo
      </button>
    );
  }

  // Default variant - card
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border-2 border-blue-100 hover:border-blue-300 transition-all">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
            <CalendarDaysIcon className="w-6 h-6 text-white" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900 mb-2">Need Help Getting Started?</h3>
          <p className="text-sm text-gray-600 mb-4">
            Book a free demo with our team. We'll walk you through the toolkit features and answer
            any questions you have about managing your properties.
          </p>
          <button
            onClick={handleBookDemo}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg font-semibold text-sm hover:bg-blue-700 transition-all shadow-sm hover:shadow-md"
          >
            <EnvelopeIcon className="w-5 h-5" />
            Book a Demo
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookDemoCard;
